// extracted by mini-css-extract-plugin
export default {"compContainer":"keyBtn_compContainer__Ul5Ap","icon":"keyBtn_icon__pfpv0"};